/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditDetailsDTO } from '../models/AuditDetailsDTO';
import type { AuditStateEnum } from '../models/AuditStateEnum';
import { request as __request } from '../core/request';

export class AuditsVService {

    /**
     * @param tableName
     * @param state
     * @param keyValue
     * @param userId
     * @param fromDateTime
     * @param toDateTime
     * @returns AuditDetailsDTO OK
     * @throws ApiError
     */
    public static async auditsVGetAll(
        tableName?: string,
        state?: AuditStateEnum,
        keyValue?: string,
        userId?: string,
        fromDateTime?: string,
        toDateTime?: string,
    ): Promise<Array<AuditDetailsDTO>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/audits`,
            query: {
                'TableName': tableName,
                'State': state,
                'KeyValue': keyValue,
                'UserId': userId,
                'FromDateTime': fromDateTime,
                'ToDateTime': toDateTime,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}